/* RESPONSIBLE TEAM: team-data-foundations */
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class ChannelIdentityRulesEditRoute extends WorkspaceSettingsRoute {
  @service declare intl: IntlService;

  get titleToken() {
    return this.intl.t('new-settings.workspace.channel-identity-rules.modal.edit-title');
  }

  model(params: { id: string }) {
    return {
      id: params.id,
    };
  }
}
